import { COWHIDE } from "@/data/site";

// CSS 3D preview of the cushion, scaled to dimensions.
// topFab / sideFab: { texture?: url, color?: hex }
export default function CushionPreview({ length, width, height, piping, topFab, sideFab }) {
  const top = topFab || { texture: COWHIDE.texture };
  const side = sideFab || top;

  const L = Number(length) || 0;
  const W = Number(width) || 0;
  const H = Number(height) || 0;
  const ready = L > 0 && W > 0;

  const scale = 220 / Math.max(L, W, 12);
  const wpx = Math.max(24, L * scale);
  const dpx = Math.max(24, W * scale);
  const hpx = Math.max(16, Math.min((H || 3) * scale, 130));

  const bg = (f) => (f.texture
    ? { backgroundImage: `url(${f.texture})`, backgroundSize: "150px" }
    : { backgroundColor: f.color || "#6b4a2f" });

  const pipingStyle = piping ? { boxShadow: "inset 0 0 0 2px rgba(250,250,248,0.9)" } : {};

  const face = (w, h, transform, brightness, fab) => ({
    position: "absolute",
    left: "50%",
    top: "50%",
    width: `${w}px`,
    height: `${h}px`,
    marginLeft: `${-w / 2}px`,
    marginTop: `${-h / 2}px`,
    transform,
    filter: `brightness(${brightness})`,
    borderRadius: "10px",
    ...bg(fab),
    ...pipingStyle,
  });

  return (
    <div className="relative flex h-[360px] w-full items-center justify-center overflow-hidden rounded-sm bg-paper-soft">
      <div className="grain absolute inset-0 opacity-40" />
      {!ready ? (
        <p className="relative z-10 max-w-[220px] text-center text-sm text-teal-anchor/50">
          Enter your length and width to see your custom cushion come to life.
        </p>
      ) : (
        <div style={{ perspective: "1100px" }} className="relative z-10">
          <div style={{ transformStyle: "preserve-3d", transform: "rotateX(-22deg) rotateY(-34deg)", width: `${wpx}px`, height: `${dpx}px`, position: "relative" }}>
            <div style={face(wpx, dpx, `rotateX(90deg) translateZ(${-hpx / 2}px)`, 0.6, top)} />
            <div style={face(dpx, hpx, `rotateY(90deg) translateZ(${wpx / 2}px)`, 0.72, side)} />
            <div style={face(dpx, hpx, `rotateY(-90deg) translateZ(${wpx / 2}px)`, 0.72, side)} />
            <div style={{ ...face(wpx, hpx, `translateZ(${dpx / 2}px)`, 0.88, side), overflow: "hidden" }}>
              <div style={{ position: "absolute", left: 0, right: 0, top: "50%", height: "3px", marginTop: "-1.5px", background: "linear-gradient(90deg, rgba(220,220,220,0.9), rgba(255,255,255,0.6))" }} />
            </div>
            <div style={face(wpx, hpx, `rotateY(180deg) translateZ(${dpx / 2}px)`, 0.82, side)} />
            <div style={face(wpx, dpx, `rotateX(90deg) translateZ(${hpx / 2}px)`, 1.06, top)} />
          </div>
        </div>
      )}

      {ready && (
        <div className="absolute bottom-3 left-3 z-10 rounded-sm bg-teal-anchor/85 px-3 py-1.5 text-[11px] font-medium tracking-wide text-paper">
          {L}" L × {W}" W × {H || 0}" H
        </div>
      )}
    </div>
  );
}
